export default __webpack_public_path__ + "static/media/logo_db.f00d88fc.svg";